import { render, staticRenderFns } from "./SaveResourceModal.vue?vue&type=template&id=45451965&scoped=true"
import script from "./SaveResourceModal.vue?vue&type=script&lang=js"
export * from "./SaveResourceModal.vue?vue&type=script&lang=js"
import style0 from "./SaveResourceModal.vue?vue&type=style&index=0&id=45451965&prod&lang=less&scoped=true"
import style1 from "./SaveResourceModal.vue?vue&type=style&index=1&id=45451965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45451965",
  null
  
)

export default component.exports